// extracted by mini-css-extract-plugin
module.exports = {"container":"inAppPage_container__qP4QP","floating-cta":"inAppPage_floating-cta__PInJn"};